import React from "react";
import {
	Switch,
	BrowserRouter
} from "react-router-dom";
import {
	RouteWithLayout
} from "../components";
import {
	ErrorContent,
	WelcomeLoading
} from "./components";
import {
	Faq as FaqPage,
	Profile as ProfilePage,
	Services as ServicesPage,
	Settings as SettingsPage,
	Dashboard as DashboardPage,
	ServiceSlug as ServiceSlugPage,
	TopUpBalance as TopUpBalancePage,
	BalanceHistory as BalanceHistoryPage,
	NumbersReceived as NumbersReceivedPage,
	TopUpBalanceSlug as TopUpBalanceSlugPage,
	TopUpBalanceHash as TopUpBalanceHashPage
} from "../pages";
import MainLayout from "../layouts/Main";
import {compose} from "recompose";
import {connect} from "react-redux";
import {getPopularServices} from "../redux/stores/services";
import {getConfig} from "../redux/stores/config";
import {changeLocale, changeCurrency, getUser, updateBalance} from "../redux/stores/profile";
import {getItemFromLocalStorage} from "../utils/localstorage";
import {dictionaries} from "../languages/getTrans";
import {normalizeLocale} from "../languages/normalizeLocale";
import {getFaqItems} from "../redux/stores/faq";

const pages = [
	{
		path: '/',
		component: DashboardPage,
		rules: [],
		exact: true
	},
	{
		path: '/services',
		component: ServicesPage,
		rules: [],
		exact: true
	},
	{
		path: '/services/:slug',
		component: ServiceSlugPage,
		rules: [],
		exact: true
	},
	{
		path: '/settings',
		component: SettingsPage,
		rules: [],
		exact: true
	},
	{
		path: '/faq',
		component: FaqPage,
		rules: [],
		exact: true
	},
	{
		path: '/numbers-received',
		component: NumbersReceivedPage,
		rules: [],
		exact: true
	},
	{
		path: '/top-up-balance',
		component: TopUpBalancePage,
		rules: [],
		exact: true
	},
	{
		path: '/top-up-balance/:countrySlug/:groupSlug/:itemId',
		component: TopUpBalanceSlugPage,
		rules: [],
		exact: true
	},
	{
		path: '/top-up-balance/hash/:hash',
		component: TopUpBalanceHashPage,
		rules: [],
		exact: true
	},
	{
		path: '/balance-history',
		component: BalanceHistoryPage,
		rules: [],
		exact: true
	},

	{
		path: '/profile',
		component: ProfilePage,
		rules: [],
		exact: true
	},
];

class Route extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isError: false,
			isLoading: true,
		};

		this.refBrowserRouter = React.createRef();
		this.timeoutUpdateBalance = null;
	}

	componentDidMount = async () => {
		await this.initConfig();
		await this.props.getConfig();

		await this.props.getUser();
		if (!this.props.profile) {
			await this.setState({
				isError: true,
				isLoading: false
			});
			return
		}

		await this.props.getFaqItems();
		await this.props.getPopularServices();
		await this.setState({ isLoading: false });

		this.callTgEvents();

		this.initStartParam();
		await this.updateBalance();
	}

	initConfig = async () => {
		const _localeUser = window?.Telegram?.WebApp?.initDataUnsafe?.user?.language_code || 'en';
		let locale = getItemFromLocalStorage('locale');
		if (!locale) {
			const normalizedLocale = normalizeLocale(_localeUser);
			if (dictionaries[normalizedLocale]) {
				locale = normalizedLocale;
			}
		}

		if (!!locale) {
			this.props.changeLocale(normalizeLocale(locale));
		}

		let currency = 'usd';
		this.props.changeCurrency(currency);
	};
	callTgEvents = () => {
		// window.Telegram.WebApp.onEvent("backButtonClicked", () => {
		// 	if (this.refBrowserRouter?.current?.history) {
		// 		this.refBrowserRouter.current.history.goBack();
		// 	}
		// });
	}
	initStartParam = () => {
		const startParam = window?.Telegram?.WebApp?.initDataUnsafe?.start_param || "";
		if (!startParam) {
			return
		}

		let itemsInits = {};
		String(startParam || '').split("_").map((item) => {
			const [key, value] = item.split("=");
			itemsInits[key] = value;
		});

		if (itemsInits?.hash) {
			this.refBrowserRouter.current.history.push(`/top-up-balance/hash/${ itemsInits?.hash }`);
			return;
		}
		if (itemsInits?.payments) {
			this.refBrowserRouter.current.history.push('/balance-history');
			return;
		}
	}

	updateBalance = async () => {
		clearTimeout(this.timeoutUpdateBalance);
		await this.props.updateBalance();
		this.timeoutUpdateBalance = setTimeout(async () => {
			await this.updateBalance();
		}, (20 * 1000))
	}

	render () {
		const {
			isError,
			isLoading
		} = this.state;

		if (isLoading) {
			return (
				<WelcomeLoading/>
			)
		}
		if (isError) {
			return (
				<ErrorContent/>
			)
		}
		return (
			<BrowserRouter
				ref={this.refBrowserRouter}
				forceRefresh={false}
			>
				<MainLayout>
					<Switch>
						{pages.map((page) => <RouteWithLayout key={`RouteWithLayout-${ page.path }`} {...page}/>)}
					</Switch>
				</MainLayout>
			</BrowserRouter>
		)
	}
}

export default compose(
	connect(
		state => ({
			profile: state?.profile?.user
		}),
		dispatch => ({
			getUser: () => dispatch(getUser()),
			getConfig: () => dispatch(getConfig()),
			getFaqItems: () => dispatch(getFaqItems()),
			updateBalance: () => dispatch(updateBalance()),
			getPopularServices: () => dispatch(getPopularServices()),
			changeLocale: (val) => dispatch(changeLocale(val)),
			changeCurrency: (val) => dispatch(changeCurrency(val)),
		}),
	),
)(Route);
